import request from "@/utils/request"
const platform = localStorage.getItem('platform')

export function getWorkers(data) {
    return request.get(`/${platform}/workers`,data)
}

export function storeOrUpdateWorker(data) {
    const method = data.id ? 'put' : 'post'
    const url = data.id ? `/${platform}/workers/${data.id}` : `/${platform}/workers`;
    return request[method](url, data)
}

export function dingtalkBind(data) {
    return request.post(`/${platform}/workers/dingtalk_bind`,data)
}

export function toggleSyncMaterial(data) {
    return request.post(`/${platform}/workers/toggle_sync_material`,data)
}

export function batchToggleSyncMaterial(data) {
    return request.post(`/${platform}/workers/batch_toggle_sync_material`,data)
}
